import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TOAGameEvent} from "../events/TOAGameEvent";
import {Elastic, Linear, TimelineLite, TweenLite} from "gsap";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TombOfAkhenatenReelSymbol} from "../symbols/TombOfAkhenatenReelSymbol";
import {TombOfAkhenatenParsedInitData} from "../server/data/TombOfAkhenatenParsedInitData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {TombOfAkhenatenGameModuleConfig} from "../TombOfAkhenatenGameModuleConfig";

export class TombOfAkhenatenReelAreaView extends ReelAreaView {

    public static maskHeightMap: Map<number, number> = new Map<number, number>([
        [3, 188],
        [4, 138.5],
        [5, 108.8],
    ]);
    private _reelAreaHeight: number;
    private _stonePressDuration: number;
    private _stonePressStartDelay: number;
    private _initGameData: TombOfAkhenatenParsedInitData;
    private _reelViewsTl: TimelineLite;

    constructor(resourcesGroup?: ResourcesGroupName) {
        super(resourcesGroup);
    }

    private static isExtendedSym(symbolName: string): boolean {
        return (TombOfAkhenatenGameConfig.instance.OVERLAPPING_SYMBOLS.indexOf(symbolName) > -1);
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, TOAGameEvent.UPDATE_REEL_POSITIONS, () => this.updateReelPositions());
        EventHandler.addEventListener(this, TOAGameEvent.ON_STONE_PRESS, (event: GameEvent) => this.onStonePress(event.params[0]));

        EventHandler.addEventListener(this, "updateReelsForAs", (event: GameEvent) => {
            let _this = this;
            this._reelAreaHeight = TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT;
            this._reelViews.forEach(function (reelView, reelId) {
                _this.arrangeSymGraphicsForAS(reelView, event.params[0]);
                _this.setReelsHeightAndMaskForAS(reelView, reelId, event.params[0]);
            });
        });

        EventHandler.addEventListener(this, TOAGameEvent.ON_STONE_PRESS_ABORT, () => this.onStonePressAbort());
        //EventHandler.addEventListener(this, TOAGameEvent.ON_SPIN_START, () => this.reArrangeReelsInSeq());
        EventHandler.addEventListener(this, TOAGameEvent.RE_ARRANGE_REEL_SEQUENCE, () => this.reArrangeReelsInSeq());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.UPDATE_REEL_VIEW_BY_REEL_ID, (event: GameEvent) => this.updateReelPosByReelId(event.params[0], event.params[1]));
    }

    protected initAnimations() {
        super.initAnimations && super.initAnimations();
        this.checkGameRestore();
    }

    private onInitDataParsed(data: TombOfAkhenatenParsedInitData): void {
        this._initGameData = data;
    }

    private checkGameRestore(): void {
        if (this._initGameData.isRestoreState) {
            TombOfAkhenatenGameConfig.instance.GAME_RESTORED = true;
            !this._initGameData.isRestoreState && (TombOfAkhenatenGameConfig.instance.REELS_ON_TOP = []);
            EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.UPDATE_REEL_POSITIONS));
            this.onStonePress(this._initGameData.activeRowsNextSpin);
            TombOfAkhenatenGameModuleConfig.reelDividerView.setDividerPositions(this._initGameData.activeRowsNextSpin);
            EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.SYM_STATE_HANDLER));

            const tl: TimelineLite = new TimelineLite();
            tl.add(() => {
                EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ON_RESTORE, this._initGameData.activeRowsNextSpin));
            }, 0.5);
            tl.play(0);
        }
    }

    private updateReelPositions(): void {
        let _this = this;

        this._reelAreaHeight = TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT;
        this._stonePressDuration = TombOfAkhenatenGameConfig.instance.STONE_PRESS_DURATION;
        this._stonePressStartDelay = TombOfAkhenatenGameConfig.instance.STONE_PRESS_START_DELAY;

        this._reelViews.forEach(function (reelView, reelId) {
            _this.updateReelViewPosition(reelView, reelId);
        });
    }

    private onStonePressAbort() {
        if (this._reelViewsTl?.isActive()) {
            this._reelViewsTl.progress(1);
        }
    }

    private onStonePress(rowCount: number): void {
        let _this = this;
        if (this._reelViewsTl?.isActive()) {
            this._reelViewsTl.progress(1).kill();
        }
        this._reelViewsTl = new TimelineLite();
        this._reelViews.forEach(function (reelView, reelId) {
            _this._reelViewsTl.add(_this.pressDownReels(reelView, reelId, rowCount), 0);
            _this._reelViewsTl.add(_this.arrangeSymGraphics(reelView, rowCount), 0);
        });
    }

    private updateReelPosByReelId(reelId: number, rowCount: number) {
        let reelViewIndex: number,
            reelViewPos: number,
            maxRowCount: number = TombOfAkhenatenGameConfig.instance.MAX_ROWS,
            currReelIndex: number = rowCount - TombOfAkhenatenGameConfig.instance.MAX_COLS;

        if (currReelIndex < 0) {
            reelViewIndex = (reelId % maxRowCount) + currReelIndex;
        } else {
            reelViewIndex = (reelId % maxRowCount) - currReelIndex;
        }

        reelViewPos = (reelViewIndex * (this._reelAreaHeight / rowCount));
        //413
        //reelViewPos = Math.max(reelViewPos, 0);
        this._reelViews[reelId].y = reelViewPos + TombOfAkhenatenGameConfig.instance.SYMBOL_BOTTOM_MARGIN;
    }

    private pressDownReels(reelView: PIXI.Container, reelId: number, rowCount: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        let reelViewIndex: number,
            reelViewPos: number,
            maxRowCount: number = TombOfAkhenatenGameConfig.instance.MAX_ROWS,
            currReelIndex: number = rowCount - TombOfAkhenatenGameConfig.instance.MAX_COLS,
            currentSymbol: TombOfAkhenatenReelSymbol = (Reels.getSymbol(reelId, 0)) as TombOfAkhenatenReelSymbol;

        if (currReelIndex < 0) {
            reelViewIndex = (reelId % maxRowCount) + currReelIndex;
        } else {
            reelViewIndex = (reelId % maxRowCount) - currReelIndex;
        }

        //413
        /*if (TombOfAkhenatenReelAreaView.isExtendedSym(currentSymbol.symName)) {
            reelViewPos = (reelViewIndex * (this._reelAreaHeight / rowCount)) - 4;
        } else {
            reelViewPos = (reelViewIndex * (this._reelAreaHeight / rowCount));
        }
        reelViewPos = Math.max(reelViewPos, 0);*/

        reelViewPos = (reelViewIndex * (this._reelAreaHeight / rowCount));

        tl.add(TweenLite.fromTo(reelView.position, this._stonePressDuration, {
            y: reelView.y
        }, {
            delay: this._stonePressStartDelay,
            y: reelViewPos + TombOfAkhenatenGameConfig.instance.SYMBOL_BOTTOM_MARGIN,
            ease: Elastic.easeOut.config(1, 0.4)
        }), 0);

        //code for reel mask dynamic height
        if (reelView.children[0].name === "reelMask_" + reelId) {
            let reelMask: PIXI.Graphics = (reelView.children[0] as PIXI.Graphics),
                maskNewHeight: number = TombOfAkhenatenReelAreaView.maskHeightMap.get(rowCount) || 188;//(this._reelAreaHeight / rowCount) - 10;
            if (TombOfAkhenatenReelAreaView.isExtendedSym(currentSymbol.symName)) {
                maskNewHeight = ((this._reelAreaHeight / rowCount) - 10) + (TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS - TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT);
            }

            tl.add(TweenLite.to(reelMask, this._stonePressDuration, {
                height: maskNewHeight,
                delay: 0.1
            }), 0);
        }

        return tl;
    }

    private setReelsHeightAndMaskForAS(reelView: PIXI.Container, reelId: number, rowCount: number): void {
        let yPos: number = 0;
        const symIdx: number = reelId % 5;
        if (rowCount === 3) {
            if (reelView.children[0].name.includes("reelMask")) {
                (reelView.children[0] as PIXI.Graphics).height = 188;
            }
            if (TombOfAkhenatenReelAreaView.isExtendedSym( ((Reels.getSymbol(reelId, 0)) as TombOfAkhenatenReelSymbol).symName)) {
                (reelView.children[0] as PIXI.Graphics).height = ((this._reelAreaHeight / rowCount) - 10) + (TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS - TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT);
            }
            if (symIdx === 0) {
                reelView.position.y = -401;
            } else if (symIdx === 1) {
                reelView.position.y = -203;
            } else if (symIdx === 2) {
                reelView.position.y = 5;
            } else if (symIdx === 3) {
                reelView.position.y = 203;
            } else if (symIdx === 4) {
                reelView.position.y = 401;
            }
        } else if (rowCount === 4) {
            if (reelView.children[0].name.includes("reelMask")) {
                (reelView.children[0] as PIXI.Graphics).height = 138.5;
            }
            if (TombOfAkhenatenReelAreaView.isExtendedSym( ((Reels.getSymbol(reelId, 0)) as TombOfAkhenatenReelSymbol).symName)) {
                (reelView.children[0] as PIXI.Graphics).height = ((this._reelAreaHeight / rowCount) - 10) + (TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS - TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT);
            }
            if (symIdx === 0) {
                reelView.position.y = -148.5;
            } else if (symIdx === 1) {
                reelView.position.y = 0;
            } else if (symIdx === 2) {
                reelView.position.y = 148.5;
            } else if (symIdx === 3) {
                reelView.position.y = 297;
            } else if (symIdx === 4) {
                reelView.position.y = 445.5;
            }
        } else if (rowCount === 5) {
            if (reelView.children[0].name.includes("reelMask")) {
                (reelView.children[0] as PIXI.Graphics).height = 108.8;
            }
            if (TombOfAkhenatenReelAreaView.isExtendedSym( ((Reels.getSymbol(reelId, 0)) as TombOfAkhenatenReelSymbol).symName)) {
                (reelView.children[0] as PIXI.Graphics).height = ((this._reelAreaHeight / rowCount) - 10) + (TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS - TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT);
            }
            if (symIdx === 0) {
                reelView.position.y = 0;
            } else if (symIdx === 1) {
                reelView.position.y = 118.8;
            } else if (symIdx === 2) {
                reelView.position.y = 237.6;
            } else if (symIdx === 3) {
                reelView.position.y = 356.4;
            } else if (symIdx === 4) {
                reelView.position.y = 475.2;
            }
        }
    }

    private arrangeSymGraphics(reelView: PIXI.Container, rowCount: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (this._initGameData.isRestoreState && rowCount == 3) {
            return tl; // to fixed #146
        }
        let bottomFramePosition: number = rowCount === 4 ? -54 : -79;
        let lowSymScaling: number = rowCount === 5 ? 0.8 : 1;
        let lowSymAnchorPositioning: number [] = rowCount === 4 ? [0.5, 0.6] : [0.5, 0.725];
        let textPositioning: number = rowCount === 4 ? -30 : -52;
        let textScaling: number = rowCount === 4 ? 0.9 : 0.8;
        let symMaskHeight: number = rowCount === 4 ? 176 : 147;

        (<PIXI.Sprite[]>(reelView.children[1] as PIXI.Sprite).children).forEach((sprite: PIXI.Sprite) => {
            if (sprite.name) {
                if (sprite.name.indexOf("_frameBottom") > -1) {
                    tl.add(TweenLite.fromTo(sprite.position, this._stonePressDuration, {
                        y: sprite.position.y
                    }, {
                        delay: this._stonePressStartDelay,
                        y: bottomFramePosition,
                        ease: Linear.easeNone
                    }), 0);
                }

                if (sprite.name.indexOf("L") > -1) {
                    if (sprite.name.indexOf("_symImage") > -1) {
                        tl.add(TweenLite.fromTo(sprite.scale, this._stonePressDuration, {
                            x: sprite.scale.x,
                            y: sprite.scale.y
                        }, {
                            delay: this._stonePressStartDelay,
                            x: lowSymScaling,
                            y: lowSymScaling,
                            ease: Linear.easeNone
                        }), 0);
                    }

                    if ((sprite.name.indexOf("_bg") > -1) || (sprite.name.indexOf("_symImage") > -1)) {
                        tl.add(TweenLite.fromTo(sprite.anchor, this._stonePressDuration, {
                            x: sprite.anchor.x,
                            y: sprite.anchor.y
                        }, {
                            delay: this._stonePressStartDelay,
                            x: lowSymAnchorPositioning[0],
                            y: lowSymAnchorPositioning[1],
                            ease: Linear.easeNone
                        }), 0);
                    }
                }

                if ((sprite.name.indexOf("S") > -1) || (sprite.name.indexOf("W") > -1)) {
                    if (sprite.name.indexOf("_textImg") > -1) {
                        tl.add(TweenLite.fromTo(sprite.position, this._stonePressDuration, {
                            y: sprite.position.y
                        }, {
                            delay: this._stonePressStartDelay,
                            y: textPositioning,
                            ease: Linear.easeNone
                        }), 0);

                        tl.add(TweenLite.fromTo(sprite.scale, this._stonePressDuration, {
                            x: sprite.scale.x,
                            y: sprite.scale.y
                        }, {
                            delay: this._stonePressStartDelay,
                            x: textScaling,
                            y: textScaling,
                            ease: Linear.easeNone
                        }), 0);
                    }
                }

                if (sprite.name.indexOf("_symMask") > -1) {
                    tl.add(TweenLite.fromTo(sprite, this._stonePressDuration, {
                        height: sprite.height
                    }, {
                        delay: this._stonePressStartDelay,
                        height: symMaskHeight,
                        ease: Linear.easeNone
                    }), 0);
                }
            }
        });
        return tl;
    }

    private arrangeSymGraphicsForAS(reelView: PIXI.Container, rowCount: number): void {
        let bottomFramePosition: number = rowCount === 4 ? -54 : (rowCount === 3 ? 0 : -79);
        let lowSymScaling: number = rowCount === 5 ? 0.8 : 1;
        let lowSymAnchorPositioning: number [] = rowCount === 4 ? [0.5, 0.6] : (rowCount === 3 ? [0.5, 0.5] : [0.5, 0.725]);
        let textPositioning: number = rowCount === 4 ? -30 : (rowCount === 3 ? -10 : -52);
        let textScaling: number = rowCount === 4 ? 0.9 : 0.8;
        let symMaskHeight: number = rowCount === 4 ? 176 : (rowCount === 3 ? 188 : 147);
        (<PIXI.Sprite[]>(reelView.children[1] as PIXI.Sprite).children).forEach((sprite: PIXI.Sprite) => {
            if (sprite.name) {
                if (sprite.name.indexOf("_frameBottom") > -1) {
                    sprite.position.y = bottomFramePosition;
                }

                if (sprite.name.indexOf("L") > -1) {
                    if (sprite.name.indexOf("_symImage") > -1) {
                        sprite.scale.set(lowSymScaling, lowSymScaling)
                    }

                    if ((sprite.name.indexOf("_bg") > -1) || (sprite.name.indexOf("_symImage") > -1)) {
                        sprite.anchor.set(lowSymAnchorPositioning[0], lowSymAnchorPositioning[1]);
                    }
                }

                if ((sprite.name.indexOf("S") > -1) || (sprite.name.indexOf("W") > -1)) {
                    if (sprite.name.indexOf("_textImg") > -1) {
                        sprite.position.y = textPositioning;
                        sprite.scale.set(textScaling, textScaling);
                    }
                }

                if (sprite.name.indexOf("_symMask") > -1) {
                    sprite.height = symMaskHeight;
                }
            }
        });
    }

    private reArrangeReelsInSeq(): void {
        let gameConfig: TombOfAkhenatenGameConfig = TombOfAkhenatenGameConfig.instance,
            reelsOnTop = gameConfig.REELS_ON_TOP.sort(function (a, b) {
                return a - b
            });

        for (let i: number = 0; i < gameConfig.REELS_NUM; i++) {
            this._reelViews[i].parent.addChildAt(this._reelViews[i], i);
        }

        for (let i: number = 0; i < gameConfig.REELS_ON_TOP.length; i++) {
            let reelTopIndex = gameConfig.REELS_ON_TOP[i];
            this._reelViews[reelTopIndex].parent.addChild(this._reelViews[reelTopIndex]);
        }
    }
}